import React, { Component } from 'react';
import filtersStore from '../../stores/filtersStore';
import history from '../common/history.js';

class TopLabel extends Component {
  redirectToLabel = (e) => {
    const { label } = this.props
    e.preventDefault();
    let params = filtersStore.toParams();
    const labelId = label.seo_label_id || label.id

    history.push(`/label/${labelId}?${params}`);
  }

  render() {
    const { logo_grayscale_small, logo, name } = this.props.label
    const { number } = this.props
    return (
      <div
        onClick={this.redirectToLabel}
        className='flex cursor-pointer h-[48px] items-center text-[11px] font-bold text-gray-3 border-b first-of-type:border-t border-gray-11 group hover:bg-gray-15'
      >
        <div className='h-full p-2 min-w-[24px] max-w-[24px]'>
          <span>{number + 1}</span>
        </div>
        <div className='flex py-1.5 px-4 justify-between grow items-center'>
          <div className='w-[55%]'>
            <img src={logo_grayscale_small || logo} className='grayscale' />
          </div>
          <span className='group-hover:text-orange-1 text-right line-clamp-2 w-[40%]'>{name}</span>
        </div>
      </div>
    )
  }
}

export default TopLabel;
